/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var ReferralTypeEnum;

(function (ReferralTypeEnum) {
  ReferralTypeEnum["SOFT"] = "soft";
  ReferralTypeEnum["HARD"] = "hard";
})(ReferralTypeEnum || (ReferralTypeEnum = {}));